import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {QuoteCollation, QuoteCollationVap, QuotePageDataVaps} from '../../../models/quote.model';
import {NgxCurrencyConfig, NgxCurrencyInputMode} from 'ngx-currency';
import {VapQuestion} from '../../../models/underwriter.model';
import {GlobalQuestionService} from '../../../services/global-question.service';

@Component({
    selector: 'app-vaps-general-three',
    templateUrl: './vaps-general-three.component.html',
    styleUrls: ['./vaps-general-three.component.scss'],
    standalone: false
})
export class VapsGeneralThreeComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() collations: QuoteCollation[];
  @Input() collation_vaps: QuoteCollationVap[];
  @Input() question: VapQuestion;
  @Input() currentVap: QuotePageDataVaps;
  @Input() productId: any;
  @Input() sessionId: any;
  @Input() addAddons = false;
  @Output() amountChanged = new EventEmitter<number>();
  @Output() addAddonsChanged = new EventEmitter<boolean>();
  maskOptions: NgxCurrencyConfig;
  answer = '';

  constructor(private globalQuestionService: GlobalQuestionService) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.addAddons?.currentValue === true) {
      this.calculate();
      this.addAddonsChanged.emit(false);
    }
    if (changes?.question?.currentValue) {
      this.question = changes?.question?.currentValue;

      if (this.question?.answers) {
        this.question .answers_parsed = JSON.parse(this.question?.answers);
      }
    }
    if (changes?.collations?.currentValue) {
      this.collations = changes?.collations?.currentValue;
    }
    if (changes?.collation_vaps?.currentValue) {
      this.collation_vaps = changes?.collation_vaps?.currentValue;
    }
    if (changes?.currentVap?.currentValue) {
      this.currentVap = changes?.currentVap?.currentValue;
    }
    if (changes?.productId?.currentValue) {
      this.productId = changes?.productId?.currentValue;
    }
    if (changes?.productId?.currentValue || changes?.currentVap?.currentValue
      || changes?.collation_vaps?.currentValue || changes?.collations?.currentValue
      || changes?.question?.currentValue) {
      this.amountChanged.emit(0);
      this.amountChanged.emit(0);
      this.getAnswer();
    }
  }

  ngAfterViewInit(): void {
    this.maskOptions = {
      max: null,
      min: null,
      allowZero: true,
      nullable: false,
      inputMode: NgxCurrencyInputMode.Financial,
      align: 'left',
      allowNegative: false,
      prefix: 'R ',
      decimal: '.',
      suffix: '',
      thousands: ' ',
      precision: 0
    };
  }

  calculate(): void {
    this.onChange(1);
  }

  getAnswer(): void {
    this.answer = '';
    if (this.getVapPrice(this.currentVap)) {
      if (this.question?.answers_parsed?.length) {
        const item = this.question?.answers_parsed[0]?.answer?.split('|');
        if (item?.length) {
          this.answer = item[1];
        }
      }
    }
  }

  getVapPrice(v: QuotePageDataVaps): string {
    let price = '';
    for (const c of this.collations) {
      if (v.product_vaps_id === c.vaps_id) {
        price = c.prem_value.toString();
      }
    }
    return price;
  }

  onChange(action: number): void {
    if (this.answer) {
      if (action === 1) {
        this.globalQuestionService.spinner(true);
      }
      const answer = action.toString() + '|' + this.answer;
      this.globalQuestionService.saveAnswer(this.sessionId, this.question?.cent_aq_question_id, 1, '1', answer, 0, '')
        .subscribe(() => {
          if (action === 1) {
            this.globalQuestionService.resetVaps(true);
            this.globalQuestionService.spinner(false);
          } else {
            this.globalQuestionService.calcPremiumAddons(this.currentVap?.product_vaps_id, '1', this.productId)
              .subscribe((p: any[]) => {
                if (p?.length) {
                  let amount = 0;
                  p?.forEach(item => {
                    amount += +item?.premium;
                  });
                  this.amountChanged.emit(amount);
                  this.globalQuestionService.spinner(false);
                  this.globalQuestionService.resetVaps(false);
                }
              });
          }
        });
    } else {
      this.amountChanged.emit(0);
    }
  }
}
